module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "show": _vm.show,
      "on-close": _vm.close
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h3', [_vm._v(_vm._s(_vm.header))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("\n      Name\n      "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "form-control text-right",
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "form-label"
  }, [_vm._v("\n      Quota\n      "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quota),
      expression: "quota"
    }],
    staticClass: "form-control text-right",
    attrs: {
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.quota)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.quota = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "daysControl form-label"
  }, [_vm._l((_vm.weekdays), function(day) {
    return [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.activeDays),
        expression: "activeDays"
      }],
      attrs: {
        "type": "checkbox",
        "id": day
      },
      domProps: {
        "value": day,
        "checked": Array.isArray(_vm.activeDays) ? _vm._i(_vm.activeDays, day) > -1 : (_vm.activeDays)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.activeDays,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = day,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.activeDays = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.activeDays = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.activeDays = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      key: day,
      attrs: {
        "for": day
      }
    }, [_vm._v(_vm._s(day))])]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "colorControl flexRow form-label"
  }, [_vm._l((_vm.colors), function(hex, colorName) {
    return [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.color),
        expression: "color"
      }],
      key: colorName,
      staticClass: "form-control text-right",
      attrs: {
        "type": "radio",
        "name": "colorSelect",
        "id": colorName
      },
      domProps: {
        "value": colorName,
        "checked": _vm._q(_vm.color, colorName)
      },
      on: {
        "change": function($event) {
          _vm.color = colorName
        }
      }
    }), _vm._v(" "), _c('label', {
      style: ('background-color:' + hex),
      attrs: {
        "for": colorName
      }
    })]
  })], 2), _vm._v(" "), (Object.keys(_vm.children).length == 0) ? _c('label', {
    staticClass: "form-label"
  }, [_vm._v("\n      Parent Category\n      "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.parentId),
      expression: "parentId"
    }],
    staticClass: "form-control text-right",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.parentId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.parentEligibleCategories), function(category, id) {
    return _c('option', {
      key: id,
      domProps: {
        "value": id
      }
    }, [_vm._v("\n          " + _vm._s(category) + "\n        ")])
  })], 2)]) : _vm._e(), _vm._v(" "), (Object.keys(_vm.children).length != 0) ? _c('div', {
    staticClass: "form-label"
  }, [_vm._v("\n      This category is already the parent to another category.\n    ")]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "form-label"
  }, [_vm._v("\n      Order Weight\n      "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderImportance),
      expression: "orderImportance"
    }],
    staticClass: "form-control text-right",
    domProps: {
      "value": (_vm.orderImportance)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.orderImportance = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "modal-default-button",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("\n      Cancel\n    ")]), _vm._v(" "), (!_vm.isNew) ? _c('archive-category', {
    attrs: {
      "categoryId": _vm.categoryId
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isNew) ? _c('delete-category', {
    attrs: {
      "categoryId": _vm.categoryId
    }
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "modal-default-button",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n      Save\n    ")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-46bfa9ff!./~/vue-loader/lib/selector.js?type=template&index=0!./dev/src/components/CategoryModal.vue
// module id = ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-46bfa9ff!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./dev/src/components/CategoryModal.vue
// module chunks = 0